export default __webpack_public_path__ + "static/media/flower.531f08fa.png";